import styled from 'styled-components'
import { color } from 'core/theme'

export const StyledDivider = styled.hr`
  border: none;
  height: 1px;
  background-color: ${color.border};
  margin: 1rem 0;
`
